module.exports = __webpack_public_path__ + "img/quick-sigorta.3c244a7b.jpg";